import { ISobCompetitor } from 'partner360/models/ISobCompetitor'
import { ISobCompetitorsDependOnSettings } from 'partner360/models/ISobCompetitorsDependOnSettings'

interface IMapSobCompetitorToSobCompetitorDependOnSettings {
  el: ISobCompetitor
  getValue: (el: ISobCompetitor, fields: string[]) => number
  getPercent: (el: ISobCompetitor, fields: string[]) => number
}

export const mapSobCompetitorToSobCompetitorDependOnSettings = ({
  getValue,
  el,
  getPercent,
}: IMapSobCompetitorToSobCompetitorDependOnSettings): ISobCompetitorsDependOnSettings => {
  return {
    CompetitorID: el.CompetitorID,
    CompetitorName: el.CompetitorName,
    CurrentYearQ1Actuals: getValue(el, [
      'CurrentYearQ1ActualsNdpLocalCurrency',
      'CurrentYearQ1ActualsNdpUSD',
      'CurrentYearQ1ActualsNetLocalCurrency',
      'CurrentYearQ1ActualsNetUSD',
    ]),
    CurrentYearQ1ActualsSob: el.CurrentYearQ1ActualsSob ?? null,
    CurrentYearQ1YoYActuals: getPercent(el, [
      'CurrentYearQ1YoYActualsNdpLocalCurrency',
      'CurrentYearQ1YoYActualsNdpUSD',
      'CurrentYearQ1YoYActualsNetLocalCurrency',
      'CurrentYearQ1YoYActualsNetUSD',
    ]),
    CurrentYearQ1YoYActualsSob: el.CurrentYearQ1YoYActualsSob ?? null,
    CurrentYearQ1QoQActualsSob: el.CurrentYearQ1QoQActualsSob,

    CurrentYearQ2Actuals: getValue(el, [
      'CurrentYearQ2ActualsNdpLocalCurrency',
      'CurrentYearQ2ActualsNdpUSD',
      'CurrentYearQ2ActualsNetLocalCurrency',
      'CurrentYearQ2ActualsNetUSD',
    ]),
    CurrentYearQ2ActualsSob: el.CurrentYearQ2ActualsSob ?? null,
    CurrentYearQ2YoYActuals: getPercent(el, [
      'CurrentYearQ2YoYActualsNdpLocalCurrency',
      'CurrentYearQ2YoYActualsNdpUSD',
      'CurrentYearQ2YoYActualsNetLocalCurrency',
      'CurrentYearQ2YoYActualsNetUSD',
    ]),
    CurrentYearQ2YoYActualsSob: el.CurrentYearQ2YoYActualsSob ?? null,
    CurrentYearQ2QoQActualsSob: el.CurrentYearQ2QoQActualsSob,

    CurrentYearQ3Actuals: getValue(el, [
      'CurrentYearQ3ActualsNdpLocalCurrency',
      'CurrentYearQ3ActualsNdpUSD',
      'CurrentYearQ3ActualsNetLocalCurrency',
      'CurrentYearQ3ActualsNetUSD',
    ]),
    CurrentYearQ3ActualsSob: el.CurrentYearQ3ActualsSob ?? null,
    CurrentYearQ3YoYActuals: getPercent(el, [
      'CurrentYearQ3YoYActualsNdpLocalCurrency',
      'CurrentYearQ3YoYActualsNdpUSD',
      'CurrentYearQ3YoYActualsNetLocalCurrency',
      'CurrentYearQ3YoYActualsNetUSD',
    ]),
    CurrentYearQ3YoYActualsSob: el.CurrentYearQ3YoYActualsSob ?? null,
    CurrentYearQ3QoQActualsSob: el.CurrentYearQ3QoQActualsSob,

    CurrentYearQ4Actuals: getValue(el, [
      'CurrentYearQ4ActualsNdpLocalCurrency',
      'CurrentYearQ4ActualsNdpUSD',
      'CurrentYearQ4ActualsNetLocalCurrency',
      'CurrentYearQ4ActualsNetUSD',
    ]),
    CurrentYearQ4ActualsSob: el.CurrentYearQ4ActualsSob ?? null,
    CurrentYearQ4YoYActuals: getPercent(el, [
      'CurrentYearQ4YoYActualsNdpLocalCurrency',
      'CurrentYearQ4YoYActualsNdpUSD',
      'CurrentYearQ4YoYActualsNetLocalCurrency',
      'CurrentYearQ4YoYActualsNetUSD',
    ]),
    CurrentYearQ4YoYActualsSob: el.CurrentYearQ4YoYActualsSob ?? null,
    CurrentYearQ4QoQActualsSob: el.CurrentYearQ4QoQActualsSob,

    CurrentYearFYActuals: getValue(el, [
      'CurrentYearFYActualsNdpLocalCurrency',
      'CurrentYearFYActualsNdpUSD',
      'CurrentYearFYActualsNetLocalCurrency',
      'CurrentYearFYActualsNetUSD',
    ]),

    CurrentYearFYYoYActuals: getPercent(el, [
      'CurrentYearFYYoYActualsNdpLocalCurrency',
      'CurrentYearFYYoYActualsNdpUSD',
      'CurrentYearFYYoYActualsNetLocalCurrency',
      'CurrentYearFYYoYActualsNetUSD',
    ]),
    CurrentYearFYActualsSob: el.CurrentYearFYActualsSob ?? null,
    CurrentYearFYYoYActualsSob: el.CurrentYearFYYoYActualsSob ?? null,

    PrevYearQ1Actuals: getValue(el, [
      'PrevYearQ1ActualsNdpLocalCurrency',
      'PrevYearQ1ActualsNdpUSD',
      'PrevYearQ1ActualsNetLocalCurrency',
      'PrevYearQ1ActualsNetUSD',
    ]),

    PrevYearQ1YoYActuals: getPercent(el, [
      'PrevYearQ1YoYActualsNdpLocalCurrency',
      'PrevYearQ1YoYActualsNdpUSD',
      'PrevYearQ1YoYActualsNetLocalCurrency',
      'PrevYearQ1YoYActualsNetUSD',
    ]),
    PrevYearQ1ActualsSob: el.PrevYearQ1ActualsSob ?? null,
    PrevYearQ1YoYActualsSob: el.PrevYearQ1YoYActualsSob ?? null,
    PrevYearQ1QoQActualsSob: el.PrevYearQ1QoQActualsSob,

    PrevYearQ2Actuals: getValue(el, [
      'PrevYearQ2ActualsNdpLocalCurrency',
      'PrevYearQ2ActualsNdpUSD',
      'PrevYearQ2ActualsNetLocalCurrency',
      'PrevYearQ2ActualsNetUSD',
    ]),

    PrevYearQ2YoYActuals: getPercent(el, [
      'PrevYearQ2YoYActualsNdpLocalCurrency',
      'PrevYearQ2YoYActualsNdpUSD',
      'PrevYearQ2YoYActualsNetLocalCurrency',
      'PrevYearQ2YoYActualsNetUSD',
    ]),

    PrevYearQ2ActualsSob: el.PrevYearQ2ActualsSob ?? null,
    PrevYearQ2YoYActualsSob: el.PrevYearQ2YoYActualsSob ?? null,
    PrevYearQ2QoQActualsSob: el.PrevYearQ2QoQActualsSob,

    PrevYearQ3Actuals: getValue(el, [
      'PrevYearQ3ActualsNdpLocalCurrency',
      'PrevYearQ3ActualsNdpUSD',
      'PrevYearQ3ActualsNetLocalCurrency',
      'PrevYearQ3ActualsNetUSD',
    ]),

    PrevYearQ3YoYActuals: getPercent(el, [
      'PrevYearQ3YoYActualsNdpLocalCurrency',
      'PrevYearQ3YoYActualsNdpUSD',
      'PrevYearQ3YoYActualsNetLocalCurrency',
      'PrevYearQ3YoYActualsNetUSD',
    ]),

    PrevYearQ3ActualsSob: el.PrevYearQ3ActualsSob ?? null,
    PrevYearQ3YoYActualsSob: el.PrevYearQ3YoYActualsSob ?? null,
    PrevYearQ3QoQActualsSob: el.PrevYearQ3QoQActualsSob,

    PrevYearQ4Actuals: getValue(el, [
      'PrevYearQ4ActualsNdpLocalCurrency',
      'PrevYearQ4ActualsNdpUSD',
      'PrevYearQ4ActualsNetLocalCurrency',
      'PrevYearQ4ActualsNetUSD',
    ]),

    PrevYearQ4YoYActuals: getPercent(el, [
      'PrevYearQ4YoYActualsNdpLocalCurrency',
      'PrevYearQ4YoYActualsNdpUSD',
      'PrevYearQ4YoYActualsNetLocalCurrency',
      'PrevYearQ4YoYActualsNetUSD',
    ]),

    PrevYearQ4ActualsSob: el.PrevYearQ4ActualsSob ?? null,
    PrevYearQ4YoYActualsSob: el.PrevYearQ4YoYActualsSob ?? null,
    PrevYearQ4QoQActualsSob: el.PrevYearQ4QoQActualsSob,

    PrevYearFYActuals: getValue(el, [
      'PrevYearFYActualsNdpLocalCurrency',
      'PrevYearFYActualsNdpUSD',
      'PrevYearFYActualsNetLocalCurrency',
      'PrevYearFYActualsNetUSD',
    ]),

    PrevYearFYYoYActuals: getPercent(el, [
      'PrevYearFYYoYActualsNdpLocalCurrency',
      'PrevYearFYYoYActualsNdpUSD',
      'PrevYearFYYoYActualsNetLocalCurrency',
      'PrevYearFYYoYActualsNetUSD',
    ]),

    PrevYearFYActualsSob: el.PrevYearFYActualsSob ?? null,
    PrevYearFYYoYActualsSob: el.PrevYearFYYoYActualsSob ?? null,

    PrevPrevYearQ1ActualsSob: el.PrevPrevYearQ1ActualsSob,
    PrevPrevYearQ2ActualsSob: el.PrevPrevYearQ2ActualsSob,
    PrevPrevYearQ3ActualsSob: el.PrevPrevYearQ3ActualsSob,
    PrevPrevYearQ4ActualsSob: el.PrevPrevYearQ4ActualsSob,

    PrevPrevYearFYActuals: getPercent(el, [
      'PrevPrevYearFYActualsNdpLocalCurrency',
      'PrevPrevYearFYActualsNdpUSD',
      'PrevPrevYearFYActualsNetLocalCurrency',
      'PrevPrevYearFYActualsNetUSD',
    ]),
  }
}
